import React, { useMemo, useState } from "react";
import { Button, Input, Modal } from "react-daisyui";
import colors from "material-colors/dist/colors.json";
import { CirclePicker } from "react-color";

const IconColorPicker = ({
  label = "Icon Color",
  defaultValue = "#000000",
  onChange,
}) => {
  const materialColors = useMemo(() => {
    return Object.keys(colors)
      .filter((key) => typeof colors[key] === "object") // Only take the color swatches
      .flatMap((color) => {
        const swatches = colors[color];
        return Object.keys(swatches)
          .filter((shade) => !isNaN(Number(shade))) // Include only numbered shades
          .map((shade) => swatches[shade]);
      });
  }, []);
  const [color, setColor] = useState(defaultValue);

  const handleColorChange = (e) => {
    const newColor = e.target.value;
    setColor(newColor);
    if (onChange) {
      onChange({ iconColor: newColor });
    }
  };

  const onColorChange = (color) => {
    setColor(color.hex);
    if (onChange) {
      onChange({ iconColor: color.hex });
    }
  };

  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="form-control w-full">
      <label className="label">
        <span className="label-text">{label}</span>
      </label>
      <div className="flex items-center space-x-4">
        <CirclePicker onChangeComplete={onColorChange} />
        <Button color="primary" onClick={() => setIsOpen(true)}>
          More
        </Button>
        <Input
          type="color"
          value={color}
          className="input input-bordered w-16 h-10 p-0 border border-base-300 rounded-md"
          onChange={handleColorChange}
        />

        {/* Modal */}
        <Modal open={isOpen} onClickBackdrop={() => setIsOpen(false)}>
          <Modal.Header className="font-bold text-lg">
            <div className="flex justify-between gap-3">
              <span> Pick a color</span>
              <Button onClick={() => setIsOpen(false)}>Close</Button>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="flex justify-center max-h-screen-md overflow-visible max-w-screen-lg">
              <CirclePicker
                colors={materialColors}
                onChangeComplete={onColorChange}
                width="100%"
              />
            </div>
          </Modal.Body>
          <Modal.Actions></Modal.Actions>
        </Modal>
      </div>
    </div>
  );
};

export default IconColorPicker;
